export default {
  setItens(state, payload) {
    state.itens = payload;
  },
  setFornecedores(state, payload) {
    state.selects.fornecedores = payload;
  },
  setCompradores(state, payload) {
    state.selects.compradores = payload;
  },
  setAno(state, payload) {
    state.ano = payload;
  },
  setOrcamentos(state, payload) {
    if (payload) {
      state.orcamento.fornecedor = state.selects.fornecedores.find(
        c => c.value == payload.fornecedor_id
      );
      state.orcamento.comprador = state.selects.compradores.find(
        c => c.value == payload.comprador_id
      );
      state.orcamento.ano = payload.ano;
      state.orcamento.itens = payload.itens;
    } else {
      state.orcamento = {
        fornecedor: "",
        comprador: "",
        ano: "",
        itens: []
      };
    }
  },
  setOrcamento(state, payload) {
    state.orcamento.fornecedor = payload.fornecedor;
    state.orcamento.comprador = payload.comprador;
    state.orcamento.ano = payload.ano;
    if (state.orcamento.itens) {
      state.orcamento.itens.push(payload.itens);
    } else {
      state.orcamento.itens = [payload.itens];
    }
  },
  setTotalPrevistoCompra(state, payload) {
    state.orcamento.itens.find(
      oi => oi.mes == payload.mes
    ).total_previsto_compra = payload.total_previsto_compra;
  },
  excluir(state, payload) {
    state.orcamento.itens.splice(state.orcamento.itens.indexOf(payload), 1);
  }
};
